module.exports = __webpack_public_path__ + "img/calendar3-fill.55d12d66.svg";